import {
  CharityVettingUrlType,
  type CharityVettingFormValues,
  type CharityVettingUrlTypeValues,
} from 'features/charity-vetting/types/charityVettingTypes';

type CharityOnboarding = CharityVettingFormValues['charityOnboarding'];

export type VettingDeclarationConfig = {
  segment: CharityVettingUrlTypeValues;
  field: 'hasFoodSafetyManagementPlan' | 'hasHaccpProcedures';
  title: string;
  label: string;
};

export const FR_DECLARATIONS: VettingDeclarationConfig[] = [
  {
    segment: CharityVettingUrlType.FOOD_SAFETY_MANAGEMENT_PLAN_DECLARATION,
    field: 'hasFoodSafetyManagementPlan',
    title: 'Disposez-vous d’un Plan de Maîtrise Sanitaire (PMS) ?',
    label: 'Je confirme que l’association a mis en place un Plan de Maîtrise Sanitaire (PMS).',
  },
  {
    segment: CharityVettingUrlType.HACCP_DECLARATION,
    field: 'hasHaccpProcedures',
    title: 'Avez-vous mis en place des procédures HACCP & Formation Hygiène ?',
    label: 'Je confirme avoir mis en place des procédures fondées sur les principes HACCP.',
  },
];

export const declarationBySegment = (
  segment: string | undefined,
): VettingDeclarationConfig | undefined =>
  FR_DECLARATIONS.find((declaration) => declaration.segment === segment);

export const isDeclarationConfirmed = (
  charityOnboarding: Partial<CharityOnboarding> | undefined,
  { field }: VettingDeclarationConfig,
): boolean => charityOnboarding?.[field] === true;
